export function formatDateNb(date: Date | undefined): string | undefined {
    if (!date) return undefined;
    try {
        return new Intl.DateTimeFormat('nb-NO', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).format(date);
    } catch {
        return undefined;
    }
}

export function formatDateShortNb(date: Date | undefined): string | undefined {
    if (!date) return undefined;
    try {
        return new Intl.DateTimeFormat('nb-NO', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(date);
    } catch {
        return undefined;
    }
}
